const MMPLDashboardReducer = (state = {}, action) => {
  switch (action.type) {
    case "MMPLSidePanCollectDocs": {
      return Object.assign({}, state, {
        MMPLSidePanCollectDocs: action.data,
      });
      break;
    }
    case "PurchaseOrders": {
      return Object.assign({}, state, {
        PurchaseOrders: action.data,
      });
      break;
    }
    case "GetMMPLShipCountSuccess":
      return Object.assign({}, state, {
        ShipMMPLCount: action.data,
      });
      break;
    case "GetMMPLShipCountFailure":
      return Object.assign({}, state, {
        ShipMMPLCount: action.data,
      });
      break;
      case "GetClientDetailsSuccess":
        return Object.assign({}, state, {
          ClientPOs: action.data,
        });
        break;
      case "GetClientDetailsFailure":
        return Object.assign({}, state, {
          ClientPOs: action.data,
        });
        break;
    case "GetShipPOsSuccess":
      return Object.assign({}, state, {
        ShipPOs: action.data,
      });
      break;
    case "GetShipPOsFailure":
      return Object.assign({}, state, {
        ShipPOs: action.data,
      });
      break;
    case "searchSuccess":
      return Object.assign({}, state, {
        SearchResult: action.data,
      });
      break;
    case "GetMMPLShipDetailSuccess":
      return Object.assign({}, state, {
        ShipMMPLDetail: action.data,
      });
      break;
    case "GetMMPLShipDetailFailure":
      return Object.assign({}, state, {
        ShipMMPLDetail: action.data,
      });
      break;
    case "GetMMPLSearchSuccess":
      return Object.assign({}, state, {
        MMPLShipSearchResult: action.data,
      });
      break;
    case "GetMMPLSearchFailure":
      return Object.assign({}, state, {
        MMPLShipSearchResult: action.data,
      });
      break;
    case "GetMMPLPOSearchSuccess":
      return Object.assign({}, state, {
        MMPLPOShipSearchResult: action.data,
      });
      break;
    case "GetMMPLPOSearchFailure":
      return Object.assign({}, state, {
        MMPLPOShipSearchResult: action.data,
      });
      break;
    case "GetMMPLShipPendingSearchSuccess":
      return Object.assign({}, state, {
        MMPLPOShipPendingResult: action.data,
      });
      break;
    case "GetMMPLShipPendingSearchFailure":
      return Object.assign({}, state, {
        MMPLPOShipPendingResult: action.data,
      });
      break;
    case "POSuccess":
      return Object.assign({}, state, {
        POSuccess: action.data,
      });
      break;
    case "GetMMPLMdocSearchSuccess":
      return Object.assign({}, state, {
        MMPLMdocShipSearchResult: action.data,
      });
      break;
    case "GetMMPLMdocSearchFailure":
      return Object.assign({}, state, {
        MMPLMdocShipSearchResult: action.data,
      });
      break;
    case "GetMMPLIHMSearchSuccess":
      return Object.assign({}, state, {
        MMPLIHMShipSearchResult: action.data,
      });
      break;
    case "GetMMPLIHMSearchFailure":
      return Object.assign({}, state, {
        MMPLIHMShipSearchResult: action.data,
      });
      break;
    case "GetMMPLShortClosedSearchSuccess":
      return Object.assign({}, state, {
        MMPLShortClosedShipSearchResult: action.data,
      });
      break;
    case "GetMMPLShortClosedSearchFailure":
      return Object.assign({}, state, {
        MMPLShortClosedShipSearchResult: action.data,
      });
      break;
    case "GetMMPLShipInfoSuccess":
      return Object.assign({}, state, {
        MMPLShipInfo: action.data,
      });
      break;
    case "GetMMPLShipInfoFailure":
      return Object.assign({}, state, {
        MMPLShipInfo: action.data,
      });
      break;
    case "GetMMPLShipDetailSuccess":
      return Object.assign({}, state, {
        MMPLShipDetail: action.data,
      });
      break;
    case "GetMMPLShipDetailFailure":
      return Object.assign({}, state, {
        MMPLShipDetail: action.data,
      });
      break;
    case "GetMMPLShipHistorySuccess":
      return Object.assign({}, state, {
        MMPLShipHistory: action.data,
      });
      break;
    case "GetMMPLShipHistoryFailure":
      return Object.assign({}, state, {
        MMPLShipHistory: action.data,
      });
      break;
    case "getMMPLShipSearchSuccess":
      return Object.assign({}, state, {
        MMPLShipList: action.data,
      });
      break;
    case "AttachmentUploadMDocSuccess":
      return Object.assign({}, state, {
        MDocAttachment: action.data,
      });
      break;
    case "AttachmentUploadSDocSuccess":
      return Object.assign({}, state, {
        SDocAttachment: action.data,
      });
      break;
    case "CollectMdocSdocDetails":
      return Object.assign({}, state, {
        CollectMDocSDocDetails: action.data,
      });
      break;
    case "GetHazardessMaterialsSuccess":
      return Object.assign({}, state, {
        HazardessMaterials: action.data,
      });
      break;
    case "GetHazardessMaterialsFailure":
      return Object.assign({}, state, {
        HazardessMaterials: action.data,
      });
      break;
    case "PostHazardessMaterialsSuccess":
      return Object.assign({}, state, {
        HazardessMaterials: action.data,
      });
      break;
    case "PostHazardessMaterialsFailure":
      return Object.assign({}, state, {
        HazardessMaterials: action.data,
      });
      break;
    case "AddPaintCoating":
      return Object.assign({}, state, {
        AddPaintCoating: action.data,
      });
      break;
    case "AddEquipmentMachinery":
      return Object.assign({}, state, {
        AddEquipmentMachinery: action.data,
      });
      break;
    case "AddStructureHull":
      return Object.assign({}, state, {
        AddStructureHull: action.data,
      });
      break;
    case "AddStore":
      return Object.assign({}, state, {
        AddStore: action.data,
      });
      break;
    case "GetPaintCoatingSuccess":
      return Object.assign({}, state, {
        PaintCoating: action.data,
        PaintCoatingList: action.data,
      });
      break;
    case "GetPaintCoatingFailure":
      return Object.assign({}, state, {
        PaintCoating: action.data,
      });
      break;
    case "GetEquipmentMachinerySuccess":
      return Object.assign({}, state, {
        EquipmentMachinery: action.data,
        EquipmentMachineryList: action.data,
      });
      break;
    case "GetEquipmentMachineryFailure":
      return Object.assign({}, state, {
        EquipmentMachinery: action.data,
      });
      break;
    case "GetStructureAndHullSuccess":
      return Object.assign({}, state, {
        StructureAndHull: action.data,
        StructureHullList: action.data,
      });
      break;
    case "GetStructureAndHullFailure":
      return Object.assign({}, state, {
        StructureAndHull: action.data,
      });
      break;
    case "GetStoreSuccess":
      return Object.assign({}, state, {
        Store: action.data,
        StoreList: action.data,
      });
      break;
    case "GetStoreFailure":
      return Object.assign({}, state, {
        Store: action.data,
      });
      break;
    case "PostMaterialDeclarationSuccess":
      return Object.assign({}, state, {
        MaterialDeclaration: action.data,
      });
      break;
    case "PostMaterialDeclarationFailure":
      return Object.assign({}, state, {
        MaterialDeclaration: action.data,
      });
      break;
    case "GetMaterialDeclarationSuccess":
      return Object.assign({}, state, {
        GetMaterialDeclaration: action.data,
      });
      break;
    case "GetMaterialDeclarationFailure":
      return Object.assign({}, state, {
        GetMaterialDeclaration: action.data,
      });
      break;
    case "PutMaterialDeclarationSuccess":
      return Object.assign({}, state, {
        PutMaterialDeclaration: action.data,
      });
      break;
    case "PutMaterialDeclarationFailure":
      return Object.assign({}, state, {
        PutMaterialDeclaration: action.data,
      });
      break;
    case "DeleteMaterialDeclarationSuccess":
      return Object.assign({}, state, {
        DeleteMaterialDeclaration: action.data,
      });
      break;
    case "DeleteMaterialDeclarationFailure":
      return Object.assign({}, state, {
        DeleteMaterialDeclaration: action.data,
      });
      break;
    case "StaffShipId":
      return Object.assign({}, state, {
        StaffShipId: action.data,
      });
      break;
    case "MaterialDeclarationOptions":
      return Object.assign({}, state, {
        MaterialDeclarationOptions: action.data,
      });
      break;
    case "SearchMDLibraryData":
      return Object.assign({}, state, {
        SearchMDLibraryData: action.data,
      });
      break;
    case "GetCompanyNameSuccess":
      return Object.assign({}, state, {
        CompanyList: action.data,
      });
      break;
    case "GetSDocCompanyNameSuccess":
      return Object.assign({}, state, {
        SDocCompanyList: action.data,
      });
      break;
    case "GetPriorityShipCountSuccess":
      return Object.assign({}, state, {
        PriorityShipMMPLCount: action.data,
      });
      break;
    case "getKPIDashboardDataSuccess":
      return Object.assign({}, state, {
        dashboardData: action.data,
      });
    case "getTeamsListsSuccess":
      return Object.assign({}, state, {
        teamsData: action.data,
      });
    case "getUsersListSuccess":
      return Object.assign({}, state, {
        userData: action.data,
      });
    case "getTeamsSuccess":
      return Object.assign({}, state, {
        teamUserData: action.data,
      });
    case "SetTeamsUserIdSuccess":
      return Object.assign({}, state, {
        teamUserId: action.data,
      });
    case "PriorityPOSuccess":
      return Object.assign({}, state, {
        PriorityPOSuccess: action.data,
      });
      break;   
    //Dashboard
    case "GetClientSearchResultSuccess":
      return Object.assign({}, state, {
        clientSearchResult: action.data,
      });
    case "GetClientSearchResultFailure":
      return Object.assign({}, state, {
        clientSearchResult: action.data,
      });
    case "GetClientListSuccess":
      return Object.assign({}, state, {
        ClientList: action.data,
      });
    case "GetClientListFailure":
      return Object.assign({}, state, {
        ClientList: action.data,
      });
    case "getshipByEmailSuccess":
      return Object.assign({}, state, {
        getshipByEmail: action.data,
      });
    case "getshipByEmailFailure":
      return Object.assign({}, state, {
        getshipByEmail: action.data,
      }); 
         
    //Client Dashboard
    case "GetMMPLShipCountByClientIdSuccess":
      return Object.assign({}, state, {
        ShipMMPLCountByClientId: action.data,
      });
    case "GetMMPLShipCountByClientIdFailure":
      return Object.assign({}, state, {
        ShipMMPLCountByClientId: action.data,
      });  
    case "GetShipPOsByClientIdSuccess":
      return Object.assign({}, state, {
        ShipPOsByClientId: action.data,
      });
    case "GetShipPOsByClientIdFailure":
      return Object.assign({}, state, {
        ShipPOsByClientId: action.data,
      });
    case "getMMPLShipSearchByClientIdSuccess":
      return Object.assign({}, state, {
        MMPLShipListByClientId: action.data,
      });
    // case "GetShipByClientIdSuccess":
    //   return Object.assign({}, state, {
    //     ShipListByClientId: action.data,
    //   });
    // case "GetShipByClientIdFailure":
    //   return Object.assign({}, state, {
    //     ShipListByClientId: action.data,
    //   });
    case "searchSuccessByClientId":
      return Object.assign({}, state, {
        SearchResultByClientId: action.data,
      });  
    case "getClassSuccess":
      return Object.assign({}, state, {
        ShipClassData: action.data,
      });
    case "getClassFailure":
      return Object.assign({}, state, {
        ShipClassData: action.data,
      });
    case "getFlagSuccess":
      return Object.assign({}, state, {
        ShipFlagData: action.data,
      });
    case "getFlagFailure":
      return Object.assign({}, state, {
        ShipFlagData: action.data,
      });      
    default: {
      return state;
    }
  }
};
export default MMPLDashboardReducer;
